'use strict';

angular.module('amexReconciliationApp')
  .service('PreviouslyUsedAccountingFieldValuesModel',
    function PreviouslyUsedAccountingFieldValuesModel($rootScope,
                                                      TransactionSearchModel,
                                                      ModelFactory,
                                                      PreviouslyUsedAccountingFieldValuesRepository) {
      var model = ModelFactory.create(
        'PreviouslyUsedAccountingFieldValuesModel',
        ['previouslyUsedAccountingFieldValues']
      );
      var lastLoadedSiteNumber;

      TransactionSearchModel.onParamsChanged($rootScope, function () {
        var newSiteNumber = TransactionSearchModel.siteNumber();

        if (lastLoadedSiteNumber !== newSiteNumber) {
          refresh(newSiteNumber);
        }
      });

      model.refreshPreviouslyUsedAccountingFieldValues = function () {
        refresh(lastLoadedSiteNumber);
      };

      model.deletePreviouslyUsedAccountingFieldValues = function () {
        PreviouslyUsedAccountingFieldValuesRepository.deleteBySiteNumber(TransactionSearchModel.siteNumber());
        model.previouslyUsedAccountingFieldValues([]);
      };

      return model;

      function refresh(siteNumber) {
        if (!siteNumber) {
          return;
        }
        PreviouslyUsedAccountingFieldValuesRepository
          .findBySiteNumber(siteNumber)
          .then(function (newPreviouslyUsedAccountingFieldValues) {
            model.previouslyUsedAccountingFieldValues(newPreviouslyUsedAccountingFieldValues);
            lastLoadedSiteNumber = siteNumber;
          });
      }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/PreviouslyUsedAccountingFieldValuesModel.js
// module id = 584
// module chunks = 0